<template>
    <BModal
        :model-value="modal"
        scrollable
        centered
        @update:modelValue="updateModal"
    >
        <template #header>
            <div
                class="d-flex align-items-center justify-content-between modal-title w-100"
            >
                <h5 class="">Staff</h5>
                <BButton
                    variant="link"
                    class="close"
                    @click="updateModal(false)"
                >
                    <i class="ion ion-android-close"></i>
                </BButton>
            </div>
        </template>

        <BForm @submit.stop.prevent>
            <BContainer>
                <BRow>
                    <BCol cols="4">
                        <BFormGroup
                            label="Alias *"
                            label-for="alias"
                            class="text-start mb-3"
                        >
                            <BFormSelect
                                id="alias"
                                v-model="form.alias"
                                :options="aliasOptions"
                                class="form-control"
                                :class="{
                                    'is-invalid':
                                        v$.form.alias.$dirty &&
                                        v$.form.alias.$invalid,
                                }"
                            >
                                <template #first>
                                    <option disabled selected value="">
                                        Select Alias
                                    </option>
                                </template>
                            </BFormSelect>
                            <BFormInvalidFeedback
                                :state="
                                    v$.form.alias.$dirty &&
                                    v$.form.alias.$invalid
                                "
                            >
                                {{ v$.form.alias.$errors[0]?.$message }}
                            </BFormInvalidFeedback>
                        </BFormGroup>
                    </BCol>
                    <BCol cols="8">
                        <BFormGroup
                            label="Full Name *"
                            label-for="name"
                            class="text-start mb-3"
                        >
                            <BFormInput
                                v-model="form.fullname"
                                type="text"
                                id="fullname"
                                placeholder="Enter Full Name"
                                :class="{
                                    'is-invalid':
                                        v$.form.fullname.$dirty &&
                                        v$.form.fullname.$invalid,
                                }"
                            />
                            <BFormInvalidFeedback
                                :state="
                                    v$.form.fullname.$dirty &&
                                    v$.form.fullname.$invalid
                                "
                            >
                                {{ v$.form.fullname.$errors[0]?.$message }}
                            </BFormInvalidFeedback>
                        </BFormGroup>
                    </BCol>
                </BRow>
                <BRow>
                    <BCol>
                        <BFormGroup
                            label="Position *"
                            label-for="position"
                            class="text-start mb-3"
                        >
                            <BFormSelect
                                id="alias"
                                v-model="form.position"
                                :options="positionOptions"
                                class="form-control"
                                :class="{
                                    'is-invalid':
                                        v$.form.position.$dirty &&
                                        v$.form.position.$invalid,
                                }"
                            >
                                <template #first>
                                    <option disabled selected value="">
                                        Select Position
                                    </option>
                                </template>
                            </BFormSelect>
                            <BFormInvalidFeedback
                                :state="
                                    v$.form.position.$dirty &&
                                    v$.form.position.$invalid
                                "
                            >
                                {{ v$.form.position.$errors[0]?.$message }}
                            </BFormInvalidFeedback>
                        </BFormGroup>
                    </BCol>
                </BRow>
                <BRow>
                    <BCol>
                        <BFormGroup
                            label="Phone Number *"
                            label-for="contact"
                            class="text-start mb-3"
                        >
                            <BFormInput
                                v-model="form.phone"
                                type="number"
                                id="phone"
                                placeholder="Enter Phone Number"
                                :class="{
                                    'is-invalid':
                                        v$.form.phone.$dirty &&
                                        v$.form.phone.$invalid,
                                }"
                            />
                            <BFormInvalidFeedback
                                :state="
                                    v$.form.phone.$dirty &&
                                    v$.form.phone.$invalid
                                "
                            >
                                {{ v$.form.phone.$errors[0]?.$message }}
                            </BFormInvalidFeedback>
                        </BFormGroup>
                    </BCol>
                </BRow>
                <BRow>
                    <BCol>
                        <BFormGroup
                            label="Address *"
                            label-for="address"
                            class="text-start mb-3"
                        >
                            <BFormInput
                                v-model="form.address"
                                type="text"
                                id="address"
                                placeholder="Enter Address"
                                :class="{
                                    'is-invalid':
                                        v$.form.address.$dirty &&
                                        v$.form.address.$invalid,
                                }"
                            />
                            <BFormInvalidFeedback
                                :state="
                                    v$.form.address.$dirty &&
                                    v$.form.address.$invalid
                                "
                            >
                                {{ v$.form.address.$errors[0]?.$message }}
                            </BFormInvalidFeedback>
                        </BFormGroup>
                    </BCol>
                </BRow>
                <BRow>
                    <BCol cols="4">
                        <BFormGroup
                            label="Bank Name"
                            label-for="bank_name"
                            class="text-start mb-3"
                        >
                            <BFormInput
                                v-model="form.bank_name"
                                type="text"
                                id="bank_name"
                                placeholder="Bank Name"
                            />
                        </BFormGroup>
                    </BCol>
                    <BCol cols="4">
                        <BFormGroup
                            label="Account Number"
                            label-for="account_number"
                            class="text-start mb-3"
                        >
                            <BFormInput
                                v-model="form.account_number"
                                type="text"
                                id="account_number"
                                placeholder="Acc. Number"
                            />
                        </BFormGroup>
                    </BCol>
                    <BCol cols="4">
                        <BFormGroup
                            label="Account Name"
                            label-for="account_name"
                            class="text-start mb-3"
                        >
                            <BFormInput
                                v-model="form.account_name"
                                type="text"
                                id="account_name"
                                placeholder="Acc. Name"
                            />
                        </BFormGroup>
                    </BCol>
                </BRow>
                <BRow>
                    <BCol>
                        <BFormGroup
                            label="Status *"
                            label-for="status"
                            class="text-start mb-3"
                        >
                            <BFormSelect
                                id="status"
                                v-model="form.status"
                                :options="statusOptions"
                                class="form-control"
                                :class="{
                                    'is-invalid':
                                        v$.form.status.$dirty &&
                                        v$.form.status.$invalid,
                                }"
                            >
                                <template #first>
                                    <option disabled selected value="">
                                        Select Status
                                    </option>
                                </template>
                            </BFormSelect>
                            <BFormInvalidFeedback
                                :state="
                                    v$.form.status.$dirty &&
                                    v$.form.status.$invalid
                                "
                            >
                                {{ v$.form.status.$errors[0]?.$message }}
                            </BFormInvalidFeedback>
                        </BFormGroup>
                    </BCol>
                </BRow>

                <BRow>
                    <BCol>
                        <BFormGroup
                            label="Label Color"
                            label-for="label_color"
                            class="text-start mb-3"
                        >
                            <div class="d-flex align-items-center">
                                <BFormInput
                                    id="label_color"
                                    v-model="form.label_color"
                                    type="color"
                                    class="form-control-color"
                                    style="width: 50px; height: 38px; padding: 2px;"
                                />
                                <span class="ms-2 small text-muted">{{ form.label_color }}</span>
                            </div>
                        </BFormGroup>
                    </BCol>
                </BRow>
            </BContainer>
        </BForm>

        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" class="me-2" @click="handleAction"
                    >Save</BButton
                >
                <BButton variant="danger" @click="updateModal(false)"
                    >Cancel</BButton
                >
            </div>
        </template>
    </BModal>
</template>

<script setup>
import axios from "axios";
import { defineProps, defineEmits, reactive, watch } from "vue";
import {
    BModal,
    BRow,
    BContainer,
    BCol,
    BForm,
    BFormInput,
    BButton,
    BFormGroup,
    BFormInvalidFeedback,
    BFormSelect,
} from "bootstrap-vue-next";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required, minLength, maxLength } from "@vuelidate/validators";
import { useLoading } from "vue-loading-overlay";
import { useAuthStore } from "@/store/auth.js";
import { useToast } from "vue-toastification";

const auth = useAuthStore();
const $loading = useLoading();
const toast = useToast();

const aliasOptions = [
    {
        value: "Mr",
        text: "Mr",
    },
    {
        value: "Ms",
        text: "Ms",
    },
    {
        value: "Mrs",
        text: "Mrs",
    },
];

const positionOptions = [
    {
        value: "Driver",
        text: "Driver",
    },
    {
        value: "Guide",
        text: "Guide",
    },
];

const statusOptions = [
    {
        value: "Active",
        text: "Active",
    },
    {
        value: "Non Active",
        text: "Non Active",
    },
];

// Props
const props = defineProps({
    action: String,
    modal: Boolean,
    selectedData: Object,
});

// Emit
const emit = defineEmits(["update:modal", "addOrUpdate"]);

// Function to update modal visibility
const updateModal = (value) => {
    emit("update:modal", value); // Sync modal state with parent
};

const resetForm = () => {
    Object.assign(form, { ...formData });
    v$.value.$reset();
};

const formData = {
    alias: "",
    fullname: "",
    position: "",
    phone: "",
    address: "",
    status: "",
    bank_name: "",
    account_number: "",
    account_name: "",
    label_color: "#FFFFFF",
};

const form = reactive({ ...formData });

// Init data jika update
watch(
    () => props.selectedData,
    (newData) => {
        // jika props.selectedData != null (action edit)
        if (newData && Object.keys(newData).length > 0) {
            Object.assign(form, { ...newData });
        } else {
            Object.assign(form, { ...formData });
        }
    },
    { immediate: true }
);

const rules = {
    form: {
        alias: {
            required: helpers.withMessage("Alias is required", required),
        },
        fullname: {
            required: helpers.withMessage("Name is required", required),
            minLength: helpers.withMessage(
                "Name must be at least 3 characters",
                minLength(3)
            ),
        },
        position: {
            required: helpers.withMessage("Position is required", required),
        },
        phone: {
            required: helpers.withMessage("Phone number is required", required),
            minLength: helpers.withMessage(
                "Phone number must be at least 9 characters",
                minLength(9)
            ),
            maxLength: helpers.withMessage(
                "Phone number must be at most 16 characters",
                maxLength(16)
            ),
        },
        address: {
            required: helpers.withMessage("Address is required", required),
            minLength: helpers.withMessage(
                "Address must be at least 3 characters",
                minLength(3)
            ),
        },
        status: {
            required: helpers.withMessage("Status is required", required),
        },
        bank_name: {},
        account_number: {},
        account_name: {},
    },
};

const v$ = useVuelidate(rules, { form });

const handleAction = () => {
    props.selectedData.uuid ? update() : create();
};

const create = async () => {
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });
        try {
            const response = await axios.post(
                `${process.env.VUE_APP_API_URL}/staff/add`,
                {
                    alias: form.alias,
                    fullname: form.fullname,
                    position: form.position,
                    phone: form.phone,
                    address: form.address,
                    status: form.status,
                    bank_name: form.bank_name,
                    account_number: form.account_number,
                    account_name: form.account_name,
                    label_color: form.label_color,
                },
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                emit("addOrUpdate");
                toast.success(res.message);
                updateModal(false);
                resetForm();
            }
        } finally {
            loader.hide();
        }
    }
};

const update = async () => {
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });
        try {
            const response = await axios.put(
                `${process.env.VUE_APP_API_URL}/staff/edit/${props.selectedData.uuid}`,
                {
                    alias: form.alias,
                    fullname: form.fullname,
                    position: form.position,
                    phone: form.phone,
                    address: form.address,
                    status: form.status,
                    bank_name: form.bank_name,
                    account_number: form.account_number,
                    account_name: form.account_name,
                    label_color: form.label_color,
                },
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                emit("addOrUpdate");
                toast.success(res.message);
                updateModal(false);
                resetForm();
            }
        } finally {
            loader.hide();
        }
    }
};
</script>
